/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CreateOrganizationIPWhitelistResponseData } from './CreateOrganizationIPWhitelistResponseData';
import {
    CreateOrganizationIPWhitelistResponseDataFromJSON,
    CreateOrganizationIPWhitelistResponseDataFromJSONTyped,
    CreateOrganizationIPWhitelistResponseDataToJSON,
    CreateOrganizationIPWhitelistResponseDataToJSONTyped,
} from './CreateOrganizationIPWhitelistResponseData';

/**
 * 
 * @export
 * @interface DeleteOrganizationIPWhitelistResponse
 */
export interface DeleteOrganizationIPWhitelistResponse {
    /**
     * 
     */
    data?: CreateOrganizationIPWhitelistResponseData;
}

/**
 * Check if a given object implements the DeleteOrganizationIPWhitelistResponse interface.
 */
export function instanceOfDeleteOrganizationIPWhitelistResponse(value: object): value is DeleteOrganizationIPWhitelistResponse {
    return true;
}

export function DeleteOrganizationIPWhitelistResponseFromJSON(json: any): DeleteOrganizationIPWhitelistResponse {
    return DeleteOrganizationIPWhitelistResponseFromJSONTyped(json, false);
}

export function DeleteOrganizationIPWhitelistResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeleteOrganizationIPWhitelistResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : CreateOrganizationIPWhitelistResponseDataFromJSON(json['data']),
    };
}

export function DeleteOrganizationIPWhitelistResponseToJSON(json: any): DeleteOrganizationIPWhitelistResponse {
    return DeleteOrganizationIPWhitelistResponseToJSONTyped(json, false);
}

export function DeleteOrganizationIPWhitelistResponseToJSONTyped(value?: DeleteOrganizationIPWhitelistResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': CreateOrganizationIPWhitelistResponseDataToJSON(value['data']),
    };
}

